import React from 'react';

const Footer = () => {
  return (
    <footer className="content-footer footer bg-footer-theme">
      <div className="container-xxl d-flex flex-wrap justify-content-between py-2 flex-md-row flex-column">
        <div className="mb-2 mb-md-0">
          © {new Date().getFullYear()}{' '}
          <a href="https://github.com/yourusername/book-dashboard" target="_blank" rel="noopener noreferrer">
            Coin Dashboard
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 